import originalFetch from 'isomorphic-fetch';


function getAuthHeaders(headers) {
    let me = localStorage.getItem('me');
    me = JSON.parse(me);
    if (me) {
        return Object.assign({}, headers, {
            Authorization: `Bearer ${me.token}`
        });
    }
    return {};
}

function status(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    } else {
        return response.json().then((response) => Promise.reject(response));
    }
}

export default function (url, options = {}) {
    if (!options.headers) {
        options.headers = {};
    }
    options.headers = Object.assign(options.headers, getAuthHeaders(options.headers));
    return originalFetch(url, options)
        .then(status)
        .then((response) => {
            return Promise.resolve(response.json());
        }, (response) => {
            return Promise.reject(response);
        });
}


/** WEBPACK FOOTER **
 ** ./src/utils/fetch.js
 **/